import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Bottled Water',
        content: 'Reliable and hygienic bottled water delivery services ensuring fresh, purified drinking water.',
        paragraphs: [
            'Stay hydrated with our bottled water delivery service designed for homes, offices, and businesses. We provide high-quality, purified water in multiple bottle sizes with flexible delivery schedules tailored to your needs.',
            'Our advanced purification processes, contactless delivery, and excellent customer support ensure a smooth, safe, and convenient experience from order to doorstep.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Easy Online Ordering',
            'Scheduled Doorstep Delivery',
            'Safe & Sealed Water Bottles',
            'Monthly Subscription Options',
            'Customer Support & Refill Reminders'
        ],
        process: [
            "Select Bottle Size & Quantity",
            "Place Order via Website or App",
            "Secure, Contactless Packaging",
            "Fast, Scheduled Delivery",
            "Recycling & Bottle Return Option"
        ],
        faqs: [
            {
                id: 1,
                heading: 'What bottle sizes do you offer?',
                content: 'We offer 5-gallon, 1-gallon, and 500ml bottles to suit households, offices, and events.'
            },
            {
                id: 2,
                heading: 'How often is water delivered?',
                content: 'You can choose from daily, weekly, or monthly delivery schedules based on your consumption needs.'
            },
            {
                id: 3,
                heading: 'Is the water safe for infants?',
                content: 'Yes, our water undergoes multiple stages of purification and quality testing to ensure it’s safe for all age groups, including infants.'
            },
            {
                id: 4,
                heading: 'Can I modify or pause my delivery?',
                content: 'Absolutely! You can manage your delivery preferences through your account or by contacting our customer service team.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Water Dispenser',
        content: 'Cost-effective water dispenser rental service for homes, offices, and commercial spaces.',
        paragraphs: [
            'Enhance your hydration experience with our modern water dispensers, available on flexible rental plans. Perfect for homes, corporate environments, and public areas, our dispensers ensure easy access to hot and cold purified water.',
            'We offer installation, maintenance, and support so you can enjoy clean water without the hassle of ownership or upkeep.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Wide Range of Dispenser Models',
            'Flexible Monthly Rental Plans',
            'Professional Installation Service',
            'Scheduled Cleaning & Servicing',
            '24/7 Customer Assistance'
        ],
        process: [
            "Choose Dispenser Type (Hot/Cold)",
            "Request Installation or Rental",
            "Scheduled Equipment Delivery",
            "On-Site Setup & Demonstration",
            "Ongoing Maintenance & Support"
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of dispensers are available?',
                content: 'We offer both top-loading and bottom-loading water dispensers with hot, cold, and room temperature settings.'
            },
            {
                id: 2,
                heading: 'Is maintenance included in the rental?',
                content: 'Yes, we provide regular maintenance and servicing at no additional cost during your rental period.'
            },
            {
                id: 3,
                heading: 'Can I rent a dispenser short-term?',
                content: 'Yes, we offer both short-term and long-term rental options depending on your requirements.'
            },
            {
                id: 4,
                heading: 'Do you install the dispenser?',
                content: 'Absolutely. Our team will install the dispenser at your location and ensure it is functioning properly.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Water Softening',
        content: 'Advanced water softening systems to eliminate hardness and improve the quality of water.',
        paragraphs: [
            'Protect your appliances and plumbing from scale buildup with our reliable water softening services. Designed to remove excess calcium and magnesium, our systems provide soft water that’s gentle on skin, clothes, and equipment.',
            'We offer customized solutions, professional installation, and regular maintenance to ensure long-term water quality and efficiency.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Free Water Hardness Testing',
            'Customized Softening System Installation',
            'On-Site Inspection & Recommendations',
            'Periodic System Maintenance',
            'Support for Residential & Industrial Needs'
        ],
        process: [
            "Schedule On-Site Water Assessment",
            "Choose Suitable Softening System",
            "Professional Installation by Technicians",
            "System Calibration & Testing",
            "Periodic Salt Refill & Maintenance"
        ],
        faqs: [
            {
                id: 1,
                heading: 'What is hard water and why soften it?',
                content: 'Hard water contains high levels of minerals like calcium and magnesium, which can damage pipes, reduce appliance efficiency, and leave residues on skin and clothes.'
            },
            {
                id: 2,
                heading: 'Do I need a softener for city water?',
                content: 'It depends on your area’s water hardness level. We offer free testing to determine if a water softener is needed.'
            },
            {
                id: 3,
                heading: 'Is installation included?',
                content: 'Yes, our professionals handle delivery, installation, and setup of the softening system at your location.'
            },
            {
                id: 4,
                heading: 'How often does the softener need maintenance?',
                content: 'Maintenance is typically required every 6–12 months depending on usage and system type. We offer full service plans.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Water Filtration',
        content: 'Comprehensive water filtration solutions for residential complexes and commercial facilities.',
        paragraphs: [
            'Our water filtration plants are engineered to remove contaminants, impurities, and harmful substances, delivering safe and clean water for various applications. Ideal for housing societies, schools, hospitals, and factories.',
            'We provide end-to-end services including site analysis, system design, installation, and long-term maintenance with guaranteed water quality compliance.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'On-Site Water Testing & Quality Report',
            'Tailored Plant Design & Engineering',
            'RO, UV, UF & Activated Carbon Systems',
            'Installation, Commissioning & Training',
            'Annual Maintenance & Performance Audits'
        ],
        process: [
            "Water Quality Analysis & Consultation",
            "Select Filtration Method (RO, UV, etc.)",
            "Installation of Filtration Unit",
            "Initial Purity Test & System Run",
            "Filter Replacement Scheduling"
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of filtration technologies do you offer?',
                content: 'We offer RO (Reverse Osmosis), UV, UF, and multi-stage filtration based on your water quality and intended usage.'
            },
            {
                id: 2,
                heading: 'Can the plant be customized for my location?',
                content: 'Yes, we customize each filtration plant based on your water test report, usage needs, and site layout.'
            },
            {
                id: 3,
                heading: 'Do you provide AMC (Annual Maintenance Contracts)?',
                content: 'Yes, we offer full maintenance contracts including periodic filter replacement, system checks, and performance optimization.'
            },
            {
                id: 4,
                heading: 'Is the water tested after installation?',
                content: 'Absolutely. We conduct post-installation testing to ensure your water meets all safety and purity standards.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Water Testing',
        content: 'Accurate water testing services to ensure safety, purity, and compliance with health standards.',
        paragraphs: [
            'Our water testing services analyze your water for contaminants, hardness, pH levels, and other key indicators. Whether for residential, commercial, or industrial use, we help you determine if your water is safe for consumption or needs treatment.',
            'Certified by local health authorities, our testing solutions are reliable, fast, and tailored to your needs — with expert consultation on next steps if issues are detected.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'On-Site Sample Collection',
            'Lab Testing by Certified Professionals',
            'Digital & Hard Copy Reports',
            'Personalized Treatment Recommendations',
            'Follow-Up Testing & Support'
        ],
        process: [
            "Book a Testing Appointment Online",
            "Sample Collection at Your Location",
            "Laboratory Testing & Analysis",
            "Detailed Report with Results",
            "Recommendations for Treatment (if needed)"
        ],
        faqs: [
            {
                id: 1,
                heading: 'What does the water test include?',
                content: 'Our test covers bacteria, pH, hardness, TDS, nitrates, heavy metals, and other contaminants depending on your package.'
            },
            {
                id: 2,
                heading: 'Is this testing suitable for drinking water?',
                content: 'Yes, our service specifically checks whether your water meets national drinking water quality standards.'
            },
            {
                id: 3,
                heading: 'How long does testing take?',
                content: 'Typically, results are ready within 24–48 hours after sample collection.'
            },
            {
                id: 4,
                heading: 'Do I need to bring the sample to you?',
                content: 'You can either submit a sample at our facility or request on-site collection through our technicians.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Water Refill',
        content: 'Affordable and eco-friendly bottled water refill services for homes and businesses.',
        paragraphs: [
            'Our refill service provides clean, purified water delivered directly to your doorstep on a regular schedule or on-demand. Whether you use 5-gallon bottles, jugs, or dispensers, we ensure timely delivery and hassle-free pickup of empties.',
            'Reduce plastic waste and save money by refilling instead of replacing — all while enjoying the same high-quality drinking water every time.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Doorstep Delivery Service',
            'Hygienically Cleaned Bottles',
            'Real-Time Order Tracking',
            'Subscription & One-Time Orders',
            '24/7 Customer Assistance'
        ],
        process: [
            "Login to Schedule Refill",
            "Select Bottle Type & Quantity",
            "Same-Day or Next-Day Delivery",
            "Used Bottle Pickup Option",
            "Automated Refill Reminders"
        ],
        faqs: [
            {
                id: 1,
                heading: 'How do I place a refill order?',
                content: 'You can place an order via our website, mobile app, or by calling our customer care line.'
            },
            {
                id: 2,
                heading: 'Do I need to return the empty bottles?',
                content: 'Yes, we collect empty bottles during delivery to ensure reuse and sustainability.'
            },
            {
                id: 3,
                heading: 'Is there a minimum order quantity?',
                content: 'No minimum order is required — we serve both individual households and bulk refill needs.'
            },
            {
                id: 4,
                heading: 'Can I schedule automatic refills?',
                content: 'Absolutely. You can set up a weekly or monthly delivery plan based on your consumption.'
            }
        ]
    }

];

export default services;